module.exports = __webpack_public_path__ + "img/djuliImage.614c7ce9.png";